import { render, staticRenderFns } from "./AlCollapse.vue?vue&type=template&id=24e6ec8b&"
import script from "./AlCollapse.vue?vue&type=script&lang=js&"
export * from "./AlCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports